/**
 * Diagnostic context captured when an HTTP request fails, formatted so a user
 * can copy it straight into a support ticket.
 */
export interface SupportErrorContext {
  timestamp: string;             // ISO 8601, e.g. new Date().toISOString()
  method: string;                // GET / POST / ...
  url: string;                   // req.urlWithParams
  status: number;                // HTTP status (0 for network/CORS failures)
  statusText: string;
  requestId: string | null;      // outgoing 'RequestId' header salt
  correlationId: string | null;  // Application Insights operation id, when available
  user: string;                  // "First Last (email) [#id]" or "Not logged in"
  errorMessage: string;          // best available message from the error
}
